import axios from "axios";
import { batch } from "react-redux";

import {
  FETCH_BOOKSETS,
  UPDATE_BOOKSET,
  LOADING_BOOKSETS,
  REMOVE_BOOKSET,
  UPDATE_BOOK,
  FETCH_BOOKS,
  SET_BOOKSET_RESULTS_TAB
} from "./type";

import mediaServerAddress from "../config/mediaServerAddress";

/**
 * BOOKSET
 */

// fetch all the booksets
export const fetchBooksets =
  (options, callback) => async (dispatch, getStore) => {
    // Skip fetch if booksets already loaded and skipIfLoaded is true (default)
    const skipIfLoaded = options?.skipIfLoaded !== false;
    if (skipIfLoaded) {
      const { bookset } = getStore();
      const existingBooksets = Object.keys(bookset?.booksetMap || {});

      if (existingBooksets.length > 0) {
        // Booksets already loaded, skip API call

        if (callback) callback();
        return;
      }
    }

    dispatch({ type: LOADING_BOOKSETS, payload: {} });

    let query = ``;

    if (options?.isHidden !== undefined)
      query = `${query}&isHidden=${options.isHidden}`;

    if (options?.route !== undefined) query = `${query}&route=${options.route}`;

    const route = `bookset${query ? `?${query.slice(1)}` : ``}`;

    try {
      const {
        data: { booksetMap }
      } = await axios.get(route);

      dispatch({ type: FETCH_BOOKSETS, payload: { booksetMap } });

      if (callback) callback();
    } catch (error) {
      // Reset loading state on error - error UI handled by axios interceptor
      dispatch({ type: FETCH_BOOKSETS, payload: { booksetMap: {} } });
    }
  };

// save add book set
export const saveAddBookset =
  (
    formProps,
    {
      imageSrc,
      logoSrc,
      logoAltSrc,
      title,
      isHidden,
      isQuiz,
      productIds,
      logoIsHidden,
      userAccess,
      classRecord,
      classHealthCheck,
      classroomMaterialBinding,
      countriesAccess,
      productId,
      learnMode,
      tabletBatch,
      teacherTabletAccess,
      hasPrevButton,
      requiredProducts
    },
    callback
  ) =>
  async (dispatch, getStore) => {
    let imageId = null;
    let logoId = null;
    let logoAltId = null;

    if (imageSrc) {
      if (formProps[`image_0`]) {
        const fd = new FormData();
        fd.append(`image`, formProps[`image_0`]);

        //upload new image
        const {
          data: { image }
        } = await mediaServerAddress.post(`image`, fd);
        imageId = image._id;
      }
    }

    if (logoSrc) {
      if (formProps[`logo_0`]) {
        const fd = new FormData();
        fd.append(`image`, formProps[`logo_0`]);

        //upload new image
        const {
          data: { image }
        } = await mediaServerAddress.post(`image`, fd);
        logoId = image._id;
      }
    }

    if (logoAltSrc) {
      if (formProps[`logo_1`]) {
        const fd = new FormData();
        fd.append(`image`, formProps[`logo_1`]);

        //upload new image
        const {
          data: { image }
        } = await mediaServerAddress.post(`image`, fd);
        logoAltId = image._id;
      }
    }

    const {
      data: { bookset }
    } = await axios.post(`bookset`, {
      title,
      isHidden,
      isQuiz,
      imageId,
      logoId,
      logoAltId,
      productIds,
      logoIsHidden,
      userAccess,
      classRecord,
      classHealthCheck,
      classroomMaterialBinding,
      countriesAccess,
      productId,
      learnMode,
      tabletBatch,
      teacherTabletAccess,
      hasPrevButton,
      requiredProducts
    });

    dispatch({ type: UPDATE_BOOKSET, payload: { bookset } });

    if (callback) callback();
  };

// save edit book set
export const saveEditBookset =
  (
    formProps,
    {
      imageSrc,
      logoSrc,
      logoAltSrc,
      title,
      isHidden,
      isQuiz,
      logoIsHidden,
      booksetId,
      productIds,
      userAccess,
      classRecord,
      classHealthCheck,
      classroomMaterialBinding,
      countriesAccess,
      productId,
      learnMode,
      tabletBatch,
      teacherTabletAccess,
      hasPrevButton,
      requiredProducts
    },
    { coverImage, logoImage, logoAltImage },
    callback
  ) =>
  async (dispatch, getStore) => {
    let imageId = null;
    let logoId = null;
    let logoAltId = null;

    const uselessImages = {};

    if (coverImage) {
      uselessImages[coverImage._id] = true;
    }

    if (logoImage) {
      uselessImages[logoImage._id] = true;
    }

    if (logoAltImage) {
      uselessImages[logoAltImage._id] = true;
    }

    if (imageSrc) {
      if (formProps[`image_0`]) {
        const fd = new FormData();
        fd.append(`image`, formProps[`image_0`]);

        //upload new image
        const {
          data: { image }
        } = await mediaServerAddress.post(`image`, fd);
        imageId = image._id;
      } else {
        imageId = coverImage._id;
        delete uselessImages[coverImage._id];
      }
    }

    if (logoSrc) {
      if (formProps[`logo_0`]) {
        const fd = new FormData();
        fd.append(`image`, formProps[`logo_0`]);

        //upload new image
        const {
          data: { image }
        } = await mediaServerAddress.post(`image`, fd);
        logoId = image._id;
      } else {
        logoId = logoImage._id;
        delete uselessImages[logoImage._id];
      }
    }

    if (logoAltSrc) {
      if (formProps[`logo_1`]) {
        const fd = new FormData();
        fd.append(`image`, formProps[`logo_1`]);

        //upload new image
        const {
          data: { image }
        } = await mediaServerAddress.post(`image`, fd);
        logoAltId = image._id;
      } else {
        logoAltId = logoAltImage._id;
        delete uselessImages[logoAltImage._id];
      }
    }

    const {
      data: { bookset }
    } = await axios.patch(`bookset/${booksetId}`, {
      patch: {
        action: `changeCover`,
        data: {
          title,
          isHidden,
          isQuiz,
          logoIsHidden,
          imageId,
          logoId,
          logoAltId,
          productIds,
          userAccess,
          classRecord,
          classHealthCheck,
          classroomMaterialBinding,
          countriesAccess,
          productId,
          learnMode,
          tabletBatch,
          teacherTabletAccess,
          hasPrevButton,
          requiredProducts
        }
      }
    });

    //clean up old images
    await axios.delete(`image`, {
      data: { imageIds: Object.keys(uselessImages) }
    });

    dispatch({ type: UPDATE_BOOKSET, payload: { bookset } });

    if (callback) callback();
  };

export const moveBookset =
  (from, to, callback) => async (dispatch, getStore) => {
    const {
      data: { booksetMap }
    } = await axios.patch(`moveBookset`, {
      patch: {
        data: {
          from,
          to
        }
      }
    });

    dispatch({ type: FETCH_BOOKSETS, payload: { booksetMap } });

    if (callback) callback();
  };

// delete bookset (legacy hard-delete, kept for potential direct use)
export const deleteBookset =
  (booksetId, callback) => async (dispatch, getStore) => {
    // delete bookset
    await axios.delete(`bookset/${booksetId}`);

    //update booksets
    const {
      data: { booksetMap }
    } = await axios.get(`bookset`);

    dispatch({ type: FETCH_BOOKSETS, payload: { booksetMap } });

    if (callback) callback();
  };

// move bookset to trash (soft delete - can be restored)
export const trashBookset = (booksetId, callback) => async (dispatch) => {
  try {
    await axios.patch(`bookset/${booksetId}`, {
      patch: { action: "trashBookset" }
    });
    dispatch({ type: REMOVE_BOOKSET, payload: { booksetId } });
  } finally {
    if (callback) callback();
  }
};

// restore bookset from trash
export const restoreBookset = (booksetId, callback) => async (dispatch) => {
  try {
    const {
      data: { bookset }
    } = await axios.patch(`bookset/${booksetId}`, {
      patch: { action: "restoreBookset" }
    });
    dispatch({ type: UPDATE_BOOKSET, payload: { bookset } });
  } finally {
    if (callback) callback();
  }
};

// permanently delete bookset from trash (super only)
export const permanentDeleteBookset =
  (booksetId, callback) => async (dispatch) => {
    try {
      await axios.patch(`bookset/${booksetId}`, {
        patch: { action: "permanentDeleteBookset" }
      });
      // bookset was already removed from booksetMap when it was trashed
    } finally {
      if (callback) callback();
    }
  };

/**
 * Book type
 */

//save book type
export const saveBooktype =
  (
    mode,
    booktypeName,
    _booksetId,
    _booktypeId,
    callback,
    visibleLevels,
    logoImage,
    existingLogoImageId
  ) =>
  async (dispatch, getStore) => {
    let logoImageId = existingLogoImageId || null;

    // Upload new logo image if provided
    if (logoImage) {
      const fd = new FormData();
      fd.append("image", logoImage);

      const {
        data: { image }
      } = await mediaServerAddress.post("image", fd);

      logoImageId = image._id;

      // Clean up old logo image if replacing
      if (existingLogoImageId) {
        await axios.delete("image", {
          data: { imageIds: [existingLogoImageId] }
        });
      }
    }

    const action = mode === "add" ? `addBooktype` : `updateBooktype`;
    const {
      data: { bookset }
    } = await axios.patch(`bookset/${_booksetId}`, {
      patch: {
        action: action,
        data: {
          title: booktypeName,
          booktypeId: _booktypeId,
          visibleLevels: visibleLevels,
          logoImageId: logoImageId
        }
      }
    });

    dispatch({ type: UPDATE_BOOKSET, payload: { bookset } });

    _booktypeId = bookset.bookTypes[bookset.bookTypes.length - 1]._id;

    if (mode === "add") {
      //add one book automatically after adding a component
      const {
        data: { book }
      } = await axios.post(`book`, {
        title: `Level 1`,
        booksetId: _booksetId,
        booktypeId: _booktypeId,
        imageId: null,
        level: 0
      });
      dispatch({ type: UPDATE_BOOK, payload: { book } });

      //update bookset.bookTypes._book
      const _bookId = book._id;
      const {
        data: { bookset }
      } = await axios.patch(`bookset/${_booksetId}`, {
        patch: {
          action: "addBook",
          data: {
            booktypeId: _booktypeId,
            bookId: _bookId
          }
        }
      });

      dispatch({ type: UPDATE_BOOKSET, payload: { bookset } });
    }

    if (callback) callback();
  };

// move bookType
export const moveBookType =
  ({ booksetId, booktypeId }, to, callback) =>
  async (dispatch, getStore) => {
    const {
      data: { bookset }
    } = await axios.patch(`bookset/${booksetId}`, {
      patch: {
        action: "MOVE_BOOKTYPE",
        data: { booktypeId, to }
      }
    });

    dispatch({ type: UPDATE_BOOKSET, payload: { bookset } });

    if (callback) callback();
  };

// duplicate book
export const duplicateBooks =
  ({ bookIds, bookTypeId, booksetId }, callback, mode) =>
  async (dispatch, getStore) => {
    const {
      data: { bookset }
    } = await axios.patch(`bookset/${booksetId}`, {
      patch: {
        action: "duplicate_books",
        data: { bookIds, bookTypeId, mode: mode || "" }
      }
    });

    const {
      data: { bookMap }
    } = await axios.get(`book`);

    batch(() => {
      dispatch({ type: UPDATE_BOOKSET, payload: { bookset } });
      dispatch({ type: FETCH_BOOKS, payload: { bookMap } });
    });

    if (callback) callback();
  };

// duplicate booksets
export const duplicateBooksets =
  ({ booksetIds }, callback) =>
  async (dispatch, getStore) => {
    const {
      data: { booksetMap }
    } = await axios.patch(`bookset`, {
      patch: {
        action: "duplicate_booksets",
        data: { booksetIds }
      }
    });

    dispatch({ type: FETCH_BOOKSETS, payload: { booksetMap } });

    if (callback) callback();
  };

// delete bookType
export const deleteBookType =
  ({ booksetId, bookTypeIndex }, callback) =>
  async (dispatch, getStore) => {
    // delete bookType & update bookset.bookTypes
    const {
      data: { bookset }
    } = await axios.patch(`bookset/${booksetId}`, {
      patch: {
        action: "deleteBookType",
        data: {
          bookTypeIndex
        }
      }
    });

    dispatch({ type: UPDATE_BOOKSET, payload: { bookset } });

    if (callback) callback();
  };

//handle bookset in favorite list
export const handleFavorite =
  (booksetId, callback) => async (dispatch, getStore) => {
    await axios.patch(`account/bookset/${booksetId}`);
    if (callback) callback();
  };

// set bookset results active tab
export const setBooksetResultsTab = (activeTab) => ({
  type: SET_BOOKSET_RESULTS_TAB,
  payload: { activeTab }
});
